export default __webpack_public_path__ + "static/02_V1@2x-777c5134e0295436d00a9540fcec93ff.png";